export default __webpack_public_path__ + "static/media/frestin.f9623f48.jpeg";